export const CREDIT_OFFER_OPEN_DRAWER = "standard-pdp-credit-offer-open-drawer";
export const KLARNA_INSTALMENT_CLICK =
  "WPDP | Credit Offer Click | Klarna Instalment";
export const KLARNA_GENERIC_CLICK =
  "WPDP | Credit Offer Click | Klarna Generic";
